import { TypedUseSelectorHook, useSelector, useDispatch } from 'react-redux';
import { RootState } from 'types';
import type { AppDispatch } from './configureStore';

// Use throughout your app instead of plain `useAppDispatch` and `useSelector`
export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
